import { Component, OnInit, Input, Output, EventEmitter, OnChanges,
  SimpleChange, SimpleChanges, ViewChild } from '@angular/core';
import { ConfigurateurRubrique, ConfigurateurData, ConfigurateurFacade, AConfigurateurDataPE, ConfigurateurDesign, ConfigurateurMateriau, ConfigurateurModele, Constantes, ConfigurateurCouleur, RenderCanvas, ConfigurateurPoignee, ConfigurateurAccessoire, ConfigurateurVitrage, RenderModele, RenderPoignee, RenderVitrage, RenderAccessoire, RenderDefault } from "app/model/configurateur";
import { ModeleService } from "app/services/modele.service";
import { HttpApiService } from "app/services/http.api";
import { CookieService } from "angular2-cookie/services/cookies.service";

@Component({
  selector: 'app-diaporama',
  templateUrl: './diaporama.component.html',
  styleUrls: ['./diaporama.component.css']
})
export class DiaporamaComponent implements OnInit, OnChanges {
  
  @Input() Rubrique:ConfigurateurRubrique;
  @Input() Data:ConfigurateurData;
  @Input() renderCanvas:RenderCanvas;
  @Output() Close = new EventEmitter<boolean>();
  @Output() SelectItem = new EventEmitter<RenderCanvas>();
  @Output() UpdateData = new EventEmitter<ConfigurateurData>();
  
  urlImgClose:string;
  showUpload:boolean = false;
  showNoAccessoire:boolean = false;
  isTransitionTitle:boolean = false;
  isUploadBtn:boolean = true;
  configSwiper:any;
  @ViewChild('swiperWrapper') public swiperWrapper: any;

  constructor(private modeleService: ModeleService, private httpApiService: HttpApiService, private cookiesService: CookieService) { }

  ngOnInit() {
    
    this.urlImgClose = this.Data.closeImg;

    this.loadConfigSwiper();
    
  }

  loadConfigSwiper() {
    if (this.configSwiper == null) {
      this.configSwiper = {
            direction: 'vertical',
            keyboardControl: true,
            scrollbar: null,
            slidesPerView: '3',
            slidesPerColumn:'1',
            slidesPerColumnFill:'column',
            scrollbarHide: false,
            mousewheelControl: true,
            scrollbarDraggable: true,
            scrollbarSnapOnRelease: true,
            pagination: false,
            paginationClickable: false,
            centeredSlides: false,
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            spaceBetween: 20,
            slidesPerGroup:3,
           
        };
    }

 //   var swiper = new Swiper('.swiper-container', this.configSwiper);
  //   {
  //     scrollbar: '.swiper-scrollbar',
  //     scrollbarHide: true,
  //     slidesPerView: 'auto',
  //     centeredSlides: true,
  //     freeMode: true,
  //     spaceBetween: 30
  // });
    
  }

  ngOnChanges(changes: {[propKey:string] : SimpleChange}){ // {[propKey:string] : SimpleChange} or SimpleChanges

    // this.facade = this.renderCanvas.facade;

    // if (this.renderCanvas.modele != null) {
    //   this.design = this.Data.designs.find(d => d.code == this.renderCanvas.modele.codeDesign);
    //   this.materiau =  this.Data.materiaux.find(m => m.code == this.renderCanvas.modele.codeMateriau);
    //   this.modele = this.Data.modeles.find(m => m.code == this.renderCanvas.modele.codeModele);
    //   this.couleur = this.Data.couleurs.find(m => m.code == this.renderCanvas.modele.codeCouleur);
    // }
    this.showUpload = (this.Rubrique != null && this.Rubrique.code == Constantes.RUBRIQUE_FACADES);
    this.isTransitionTitle = (this.Rubrique != null && 
      (
      this.Rubrique.code == Constantes.RUBRIQUE_MODELES ||
      this.Rubrique.code == Constantes.RUBRIQUE_VITRAGES
      ));
    this.showNoAccessoire = (this.Rubrique != null && this.Rubrique.code == Constantes.RUBRIQUE_ACCESSOIRES);

    this.loadConfigSwiper();
    if(this.Rubrique.code == Constantes.RUBRIQUE_MODELES || 
      this.Rubrique.code == Constantes.RUBRIQUE_COULEURS)
      //this.Rubrique.code == Constantes.RUBRIQUE_VITRAGES ||
      //this.Rubrique.code == Constantes.RUBRIQUE_POIGNEES ||
      //this.Rubrique.code == Constantes.RUBRIQUE_ACCESSOIRES)
      {
        this.configSwiper.slidesPerColumn='2';

        if(this.Rubrique.code == Constantes.RUBRIQUE_MODELES)
        {
          //this.configSwiper.spaceBetween= 40;

        }
        else if(this.Rubrique.code == Constantes.RUBRIQUE_COULEURS){
          this.configSwiper.slidesPerView='5';
          this.configSwiper.slidesPerColumn='2';
          this.configSwiper.slidesPerGroup= '5';
          this.configSwiper.spaceBetween= 10;
        }
      }
      else {
        this.configSwiper.slidesPerColumn='1';
      }

      //$('swiper').update();
  }

    getItemCssClass(item:AConfigurateurDataPE)
    {
      let cssClass = "swiper-item";
      if(this.Rubrique.code == Constantes.RUBRIQUE_MODELES || 
      this.Rubrique.code == Constantes.RUBRIQUE_COULEURS)
      //this.Rubrique.code == Constantes.RUBRIQUE_VITRAGES ||
      //this.Rubrique.code == Constantes.RUBRIQUE_POIGNEES ||
      //this.Rubrique.code == Constantes.RUBRIQUE_ACCESSOIRES)
      {
        cssClass = "swiper-item swiper-item-2col";
      }

      if(this.Rubrique.code == Constantes.RUBRIQUE_MODELES) {
        cssClass += " modele";
      }

      if(this.Rubrique.code == Constantes.RUBRIQUE_COULEURS) {
        cssClass += " couleur";
      }

      if(this.Rubrique.code == Constantes.RUBRIQUE_VITRAGES) {
        cssClass += " vitrage";
      }

      if(this.Rubrique.code == Constantes.RUBRIQUE_POIGNEES) {
        cssClass += " poignee";
      }

      if(this.Rubrique.code == Constantes.RUBRIQUE_ACCESSOIRES) {
        cssClass += " accessoire";
      }
      return cssClass;
    }
  
    fileChange(event) {

    let clientId = this.cookiesService.get('breamud-conf-pe-clientId');
    if (clientId == null || clientId === undefined || clientId.length == 0) {
        clientId = this.Data.clientId;
    }
    
    let fileList: FileList = event.target.files;  
    if (fileList.length > 0) {  
        let file: File = fileList[0];  
        this.httpApiService.uploadFacade(file, clientId).subscribe(data => { this.loadCustomFacade(data) });;
    }  
  }

  clickNoAccessoire() {
    if (this.renderCanvas != null) {
      let renderCanvas = new RenderCanvas();
      renderCanvas.itemType =Constantes.ACCESSOIRE;
      renderCanvas.facade = this.renderCanvas.facade;
      renderCanvas.poignee = this.renderCanvas.poignee;
      renderCanvas.vitrage = this.renderCanvas.vitrage;
      renderCanvas.modele = this.renderCanvas.modele;
      renderCanvas.accessoire = null;
      this.SelectItem.emit(renderCanvas);
    }
    
  } 

  loadCustomFacade(data:ConfigurateurData) {

     data.facades.forEach(facade => {
        if (this.Data.facades.findIndex(f => f.code == facade.code) == -1) {
          this.Data.facades.push(facade);
        }
      });
  }

  getCustomFacades() {
    let liste = null;
    if (this.Rubrique != null && this.Rubrique.code === Constantes.RUBRIQUE_FACADES) {
       liste = (this.Data != null ? this.Data.facades.filter(f => f.isCustom == true) : null);
    }
    return liste;
  }

  getItems() {

    if (this.Rubrique != null && this.Rubrique.code === Constantes.RUBRIQUE_FACADES) {

      let customFacade:ConfigurateurFacade = new ConfigurateurFacade();
      customFacade.code = 'CUSTOM_FACADE';
      customFacade.name = 'Importer une facade';
      customFacade.img = 'CUSTOM_FACADE';
      

      return (this.Data != null ? this.Data.facades.filter(f => f.isCustom == false) : null);
    }
    else if (this.Rubrique != null && this.Rubrique.code === Constantes.RUBRIQUE_DESIGNS) {
      return (this.Data != null ? this.Data.designs : null);
    }
    else if (this.Rubrique != null && this.Rubrique.code === Constantes.RUBRIQUE_MATERIAUX) {
      return (this.Data != null ? this.Data.materiaux : null);
    }
    else if (this.Rubrique != null && this.Rubrique.code === Constantes.RUBRIQUE_MODELES) {

      return this.getModeles();
    }
    else if (this.Rubrique != null && this.Rubrique.code === Constantes.RUBRIQUE_COULEURS) {
      return this.getCouleursByModele();
    }
    else if (this.Rubrique != null && this.Rubrique.code === Constantes.RUBRIQUE_POIGNEES) {
      return this.getPoigneesByModele();
    }
    else if (this.Rubrique != null && this.Rubrique.code === Constantes.RUBRIQUE_ACCESSOIRES) {
      return this.getAccessoiresByModele();
    }
    else if (this.Rubrique != null && this.Rubrique.code === Constantes.RUBRIQUE_VITRAGES) {
      return this.getVitragesByModele();
    }
    return null;
  }

  getName() {
    return (this.Rubrique != null && this.Rubrique.name != null ? this.Rubrique.name : 'not init !')
  }

  getCode() {
    return (this.Rubrique != null && this.Rubrique.code != null ? this.Rubrique.code : '')

  }

  getModeles() {

      return (this.Data != null && this.Data.modeles != null && 
              this.renderCanvas != null && this.renderCanvas.modele ? 
        this.Data.modeles.filter(m => m.design.code == this.renderCanvas.modele.codeDesign && m.materiau.code == this.renderCanvas.modele.codeMateriau)  : null);
  }

  getCouleursByModele() {
      
       let listCouleursByModele = (this.Data != null && this.Data.couleurs != null && 
              this.renderCanvas != null && this.renderCanvas.modele ? 
        this.Data.couleurs.filter(c => c.codeModele == this.renderCanvas.modele.codeModele)  : null);

        return listCouleursByModele;
  }
  getPoigneesByModele() {
      return (this.Data != null && this.Data.poignees != null && 
              this.renderCanvas != null && this.renderCanvas.modele ? 
        this.Data.poignees.filter(p => p.codeModele == this.renderCanvas.modele.codeModele)  : null);
  }
  getAccessoiresByModele() {
      return (this.Data != null && this.Data.accessoires != null && 
              this.renderCanvas != null && this.renderCanvas.modele ? 
        this.Data.accessoires.filter(a => a.codeModele == this.renderCanvas.modele.codeModele)  : null);
  }
  getVitragesByModele() {
    return (this.Data != null && this.Data.vitrages != null && 
              this.renderCanvas != null && this.renderCanvas.modele ? 
        this.Data.vitrages.filter(v => v.codeModele == this.renderCanvas.modele.codeModele)  : null);
  }

  getActiveItemCssClass(item:AConfigurateurDataPE)
  {
    return (item != null && this.Rubrique != null && item.code == this.Rubrique.itemCode ? "active " : "");
  }

  computePicto(item:AConfigurateurDataPE)
  {
      if(this.Rubrique.code == Constantes.RUBRIQUE_FACADES)
      {
        let fi = item as ConfigurateurFacade;
        return (fi.picto != null && fi.picto.length > 0 ? fi.picto : item.img);
      }
      else if(this.Rubrique.code == Constantes.RUBRIQUE_ACCESSOIRES)
      {
        let fi = item as ConfigurateurAccessoire;
        return (fi.picto != null && fi.picto.length > 0 ? fi.picto : item.img);
      }
      else if(this.Rubrique.code == Constantes.RUBRIQUE_POIGNEES)
      {
        let fi = item as ConfigurateurPoignee;
        return (fi.picto != null && fi.picto.length > 0 ? fi.picto : item.img);
      }
      else if(this.Rubrique.code == Constantes.RUBRIQUE_VITRAGES)
      {
        let fi = item as ConfigurateurVitrage;
        return (fi.picto != null && fi.picto.length > 0 ? fi.picto : item.img);
      }

      return item.img;
  }

  onClickItem(itemClicked:AConfigurateurDataPE) {
    

    let renderCanvas = new RenderCanvas();
    renderCanvas.itemType =itemClicked.itemType;
    renderCanvas.facade = this.renderCanvas.facade;
    renderCanvas.poignee = this.renderCanvas.poignee;
    renderCanvas.vitrage = this.renderCanvas.vitrage
    renderCanvas.accessoire = this.renderCanvas.accessoire;
    
    this.Rubrique.itemCode = itemClicked.code;

    let currentDesign = this.renderCanvas.modele.codeDesign;
    let currentMateriau = this.renderCanvas.modele.codeMateriau;
    let currentModele = this.renderCanvas.modele.codeModele;
    let currentCouleur = this.renderCanvas.modele.codeCouleur;

    let resetModele = false, changePoignee = false, changeAccessoire= false, changeVitrage = false, changeCouleur = false;
    if (itemClicked.itemType == Constantes.FACADE) {
        
        if (itemClicked.code == "CUSTOM") {
          console.log("import facade !");
          return;
        }
        else {
          renderCanvas.facade = itemClicked as ConfigurateurFacade;
        }
     }
    else if (itemClicked.itemType == Constantes.DESIGN) {
      currentDesign = itemClicked.code;
      resetModele = true;
    }
    else if (itemClicked.itemType == Constantes.MATERIAU) {
      currentMateriau = itemClicked.code;
      resetModele = true;
    }
    else if (itemClicked.itemType == Constantes.MODELE) {
      currentModele = itemClicked.code;
      //resetModele = true;
      changeCouleur = true;
    }
    else if (itemClicked.itemType == Constantes.COULEUR) {
       currentCouleur = itemClicked.code;
       changeCouleur = true;
    }
    else if (itemClicked.itemType == Constantes.POIGNEE) {
      renderCanvas.poignee = itemClicked as ConfigurateurPoignee;
      changePoignee = true;
    }
    else if (itemClicked.itemType == Constantes.ACCESSOIRE) {
      renderCanvas.accessoire = itemClicked as ConfigurateurAccessoire;
      changeAccessoire = true;
    }
    else if (itemClicked.itemType == Constantes.VITRAGE) {
      renderCanvas.vitrage = itemClicked as ConfigurateurVitrage;
      changeVitrage = true;
    }

    if(resetModele) {
      renderCanvas.poignee = null;
      renderCanvas.accessoire = null;
      renderCanvas.vitrage = null;
    }

    let rc:RenderModele = this.modeleService.selectRenderModele(this.Data, currentDesign, currentMateriau, currentModele, currentCouleur);
    if (rc != null) {
      renderCanvas.modele = rc;

    // selection cohérente des attributs poignee/accessoire/vitrage
    
      let defRender:RenderDefault = this.modeleService.findRenderDefault(this.Data, currentDesign, currentMateriau, currentModele, currentCouleur);
      if (defRender != null) {
  
        // vérification poignée d'une porte 
        if (renderCanvas.poignee != null) {
          let poigneeExiste = this.Data.poignees.find(p => p.code == renderCanvas.poignee.code && p.codeModele == rc.codeModele);
          if (poigneeExiste == null) {
            renderCanvas.poignee = this.Data.poignees.find(p => p.code == defRender.codePoignee);
          }
          else {
            renderCanvas.poignee.x = poigneeExiste.x;
            renderCanvas.poignee.y = poigneeExiste.y;
          }
        }
        else {
          renderCanvas.poignee = this.Data.poignees.find(p => p.code == defRender.codePoignee && p.codeModele == rc.codeModele);
        }

        if (renderCanvas.poignee == null) {
          renderCanvas.poignee = this.Data.poignees.find(p => p.code == defRender.codePoignee);
        }

        // vérification accessoire d'une porte 
        if (renderCanvas.accessoire != null) {
          let accessoireExiste = this.Data.accessoires.find(a => a.code == renderCanvas.accessoire.code && a.codeModele == rc.codeModele);
          if (accessoireExiste == null) {
            renderCanvas.accessoire = this.Data.accessoires.find(a => a.code == defRender.codeAccessoire);
          }
          else {
            renderCanvas.accessoire.x = accessoireExiste.x;
            renderCanvas.accessoire.y = accessoireExiste.y;
          }
        }
        else {
          renderCanvas.accessoire = this.Data.accessoires.find(a => a.code == defRender.codeAccessoire && a.codeModele == rc.codeModele);
        }
        
        if(renderCanvas.accessoire == null) {
          renderCanvas.accessoire = this.Data.accessoires.find(a => a.code == defRender.codeAccessoire);
        }
        
        // vérification d'une porte vitrée
        if (renderCanvas.vitrage != null) {
          let vitrageExiste = this.Data.vitrages.find(v => v.code == renderCanvas.vitrage.code && v.codeModele == rc.codeModele);
          if (vitrageExiste == null) {
            renderCanvas.vitrage = this.Data.vitrages.find(p => p.code == defRender.codeVitrage);
          }
          else {
            renderCanvas.vitrage.x = vitrageExiste.x;
            renderCanvas.vitrage.y = vitrageExiste.y;
          }
        }
        else {
          renderCanvas.vitrage = this.Data.vitrages.find(p => p.code == defRender.codeVitrage);
        }
        
      }

    }
    else {
      let defRender:RenderDefault = this.modeleService.findRenderDefault(this.Data, currentDesign, currentMateriau, currentModele, currentCouleur);
      renderCanvas = this.modeleService.selectDefaultRenderCanvas(this.Data, this.renderCanvas.facade, defRender);
    }

    this.SelectItem.emit(renderCanvas);
    //this.Close.emit(true);
  }

  onClickClose() {
    this.Close.emit(true);
  }
}


// WEBPACK FOOTER //
// ./src/app/creator/diaporama/diaporama.component.ts